import $ from "jquery";
import _ from "underscore";

export default {
  showMessage: function (options) {
    var $el = $("<div></div>").addClass("alertbar");

    if (options.type) {
      $el.addClass(options.type);
    }
    if (options.icon) {
      $el.append($("<i></i>").addClass(options.icon));
    }
    if (options.text) {
      $el.append($("<span></span>").text(options.text));
    }
    $el
      .css("top", "-80px")
      .appendTo($("body"))
      .animate(
        {
          top: 0,
        },
        500,
        function () {
          setTimeout(function () {
            $el.animate(
              {
                top: "-80px",
              },
              500,
              function () {
                $el.remove();
              }
            );
          }, options.duration || 4000);
        }
      );
  },
  showSaveSuccess: function (txt, duration) {
    if (!txt) {
      duration = duration || 1500;
      txt =
        S.session.user &&
        S.session.user.sp_account &&
        S.session.user.sp_account.language == "en"
          ? "Your changes were saved"
          : "Dina ändringar sparades";
    } else {
      duration = duration || 2000;
    }
    this.showMessage({
      icon: "fui-check-circle",
      text: txt,
      type: "success",
      duration: duration,
    });
  },
  showErrorMessage: function (error) {
    var txt;
    if (typeof error == "object") {
      _.each(error, function (errors) {
        txt = typeof errors === "string" ? errors : errors.join("<br>");
      });
    } else {
      txt = error;
    }

    if (!txt) {
      txt =
        S.session.user &&
        S.session.user.sp_account &&
        S.session.user.sp_account.language == "en"
          ? "An error occured"
          : "Ett fel inträffade";
    }

    this.showMessage({
      icon: "fui-cross-circle",
      text: txt,
      type: "error",
    });
  },
};
